import { ListResult } from '@shared/api';
import { Api } from '../../Api';
import { ISettingsAuditsDto } from './interfaces';
import { ISettingsAuditsGetQuery } from './query';

export class Audits {
    private static _basePath = '/Audit';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Audits._basePath}`;
        return {
            async get(query: ISettingsAuditsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<ISettingsAuditsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
